import useMutation from "src/hooks/useMutation";

function useWarehouseRemove(id) {
  return useMutation({
    path: `/api/v1/warehouses/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouses`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseRemove;
